export default __webpack_public_path__ + "static/media/logo-porti-di-roma.554aba82.png";